import moment from 'moment-timezone';

/* global Spark */
export default function (date, format = 'L LT') {
    if (!date) return '';

    return moment(date).format(format);
}
